export default __webpack_public_path__ + "static/media/GreycliffCF-Bold.8883621d.ttf";